import Vue from 'vue';
import PortalTarget from './PortalTarget';
export { INJECT_PORTAL_CONTEXT } from './consts';
const PortalContext = Vue.extend({
  name: 'PortalContext',
  data() {
    return {
      portalTargets: {},
      fallbackPortalTarget: null
    };
  },
  created() {
    var _this$$parent;
    this.tmpEl = document.createElement('div');
    document.body.appendChild(this.tmpEl);
    this.fallbackPortalTarget = new PortalTarget({
      parent: this,
      propsData: {
        forceContext: this,
        name: 'window'
      }
    }).$mount(this.tmpEl);
    (_this$$parent = this.$parent) === null || _this$$parent === void 0 || _this$$parent.$once('hook:beforeDestroy', () => {
      this.$destroy();
    });
  },
  beforeDestroy() {
    var _el$parentElement;
    const el = this.fallbackPortalTarget.$el;
    (_el$parentElement = el.parentElement) === null || _el$parentElement === void 0 || _el$parentElement.removeChild(el);
    this.fallbackPortalTarget.$destroy();
  },
  methods: {
    getPortalTarget(targetName) {
      return this.portalTargets[targetName] || this.fallbackPortalTarget;
    }
  }
});
export default PortalContext;